// import axios from 'axios';
// const domain = window.location.origin;

// axios.defaults.baseURL = domain;
// const request = axios.create({
//   baseURL: `${domain}/w1`,
//   transformResponse: [(response) => {
//     console.log('domain', domain);
//     if (response) {
//       return JSON.parse(response).data;
//     }
//     return null;
//   }],
// });

// export default request;

import axios from 'axios';
import appConfig from "../config/api.config";

const isDev = window.location.hostname === 'localhost';
const url = appConfig.BASE_URL;
const request = axios.create({
  baseURL: `${url}/w1`,
  withCredentials: true,
  transformResponse: [(response) => {
    if (response) {
      return JSON.parse(response).data;
    }
    return null;
  }],
});

export default request;